module.exports = __webpack_public_path__ + "fonts/socicon.60e5857.eot";